export function getExchangedAmount({ rateMap = {}, amount, from, to, currencyOptions = [], digits }) {
    const { base, rates } = rateMap;
    const fromOption = currencyOptions.find(c => c.value === from);
    const toOption = currencyOptions.find(c => c.value === to);
    if (!base || !rates || !rates[from] || !rates[to] || from === to) {
        return getFormattedAmount(amount, fromOption?.alphabetCode || 'TWD', digits);
    }
    let exchangedAmount = amount;
    if (from === base) {
        exchangedAmount = amount * rates[to];
    } else if (to === base) {
        exchangedAmount = amount / rates[from];
    } else {
        exchangedAmount = amount / rates[from] * rates[to];
    }
    return getFormattedAmount(exchangedAmount, toOption?.alphabetCode, digits);
};

export function getFormattedAmount(amount, currencyCode, digits = 0) {
    return (new Intl.NumberFormat(navigator.language || 'zh-TW', {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
        trailingZeroDisplay: 'stripIfInteger'
    })).format(amount);
}
